module.exports = __webpack_public_path__ + "img/title.55bd2a4a.png";